import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createAction } from 'redux-actions';
export const fetchPrivilegesSuccess = createAction('@@gruser.PRIVILEGES.FETCH.SUCCESS', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));
